import { render, staticRenderFns } from "./detailInviceInfo.vue?vue&type=template&id=626a5626&scoped=true&"
import script from "./detailInviceInfo.vue?vue&type=script&lang=js&"
export * from "./detailInviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailInviceInfo.vue?vue&type=style&index=0&id=626a5626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a5626",
  null
  
)

export default component.exports